import { faRedo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Grid, Text } from '@raskrask-dk/rr-components'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { PropsAddressResetTemplate } from './props'
import { ResetButton, StyledAddressReset } from './styles'

const AddressResetTemplate = ({
    address,
    onClickReset,
    partner,
    isFreeConsultation,
}: PropsAddressResetTemplate): ReactElement => {
    const { t } = useTranslation()

    const resetButton = (
        <ResetButton>
            <Button onClick={onClickReset} variant="plain">
                {t('checkout.address.reset')}
                <FontAwesomeIcon icon={faRedo} />
            </Button>
        </ResetButton>
    )


    return (
        <StyledAddressReset>
            <Grid gap={4}>
                <Text primary>
                    {isFreeConsultation
                        ? `${t('checkout.address.headerFreeConsultation')}`
                        : t('checkout.address.header', { partner: partner.alias })}
                    :
                </Text>
                <Grid gap={4}>
                    <Text bold primary>
                        {address}
                    </Text>
                    {resetButton}
                </Grid>
            </Grid>
        </StyledAddressReset>
    )
}

export default AddressResetTemplate
